import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, UrlSerializer } from '@angular/router';
import { WithDynamicContent } from '@woolworthsnz/dynamic-content';
import { BreadcrumbItem, unslugify, WithPageMeta } from '@woolworthsnz/styleguide';
import { filter, map, take } from 'rxjs/operators';
import { BreadCrumbService } from '../../core/services/breadcrumb.service';

@WithPageMeta()
@WithDynamicContent({ reinitialiseOnRouteChanges: true })
@Component({
	selector: 'wnz-dynamic-content-page',
	template: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class DynamicContentPage implements OnInit {
	constructor(
		private breadCrumbService: BreadCrumbService,
		private route: ActivatedRoute,
		private router: Router,
		private serializer: UrlSerializer
	) {}

	ngOnInit(): void {
		// update the breadcrumb the first time this page is loaded, but also subscribe to subsequent navs to update breadcrumb when navigating between dynamic content pages
		this.updateBreadcrumbs();
		this.router.events
			.pipe(
				take(1),
				filter((ev) => ev instanceof NavigationEnd),
				map((ev) => ev as NavigationEnd)
			)
			.subscribe(() => {
				this.updateBreadcrumbs();
			});
	}

	private updateBreadcrumbs(): void {
		if (!this.route.snapshot.params.path) {
			// use the url to build breadcrumbs
			const urls: BreadcrumbItem[] = this.route.snapshot.url.map((url, index) => {
				// if it's not the last breadcrumb try and build a url
				if (index < this.route.snapshot.url.length - 1) {
					const routeUrl = this.serializer.serialize(
						this.router.createUrlTree(
							this.route.snapshot.url.slice(0, index + 1).map((urlSegment) => urlSegment.path),
							{ relativeTo: this.route.parent }
						)
					);
					return <BreadcrumbItem>{ text: unslugify(url.path), routeUrl };
				}
				return <BreadcrumbItem>{ text: unslugify(url.path) };
			});
			this.breadCrumbService.setBreadcrumbItems(urls);
		} else {
			this.breadCrumbService.setBreadcrumbItems([
				<BreadcrumbItem>{ text: unslugify(this.route.snapshot.params.path) },
			]);
		}
	}
}
